import { ActionTree } from 'vuex';

export interface RootState {
  onGnb: boolean;
  isShowDimmedArea: boolean;
  dimmedAreaSwitch: boolean;
  refreshIng: boolean;
  previousPath: string;
  hasUnsavedForm: boolean;
}

export const state = {
  onGnb: false,
  isShowDimmedArea: false,
  dimmedAreaSwitch: false,
  refreshIng: false,
  previousPath: '',
  hasUnsavedForm: false,
};

export const getters = {
  dimmedAreaStatus(state: RootState): boolean {
    return state.isShowDimmedArea;
  },
  dimmedAreaSwitchStatus(state: RootState): boolean {
    return state.dimmedAreaSwitch;
  },
  getPreviousPath(state: RootState): string {
    return state.previousPath;
  },
  getRefreshIng(state: RootState): boolean {
    return state.refreshIng;
  },
  hasUnsavedForm(state: RootState): boolean {
    return state.hasUnsavedForm;
  },
};
export const actions: ActionTree<RootState, any> = {
};

export const mutations = {
  SET_ONGNB(state: RootState, isOpen: boolean): void {
    state.onGnb = isOpen;
  },
  SET_DIMMEDAREA(state: RootState, isShow: boolean): void {
    state.isShowDimmedArea = isShow;
  },
  SET_REFRESHING(state: RootState, type: boolean): void {
    state.refreshIng = type;
  },
  SET_DIMMEDAREASWITCH(state: RootState, isClose: boolean): void {
    state.dimmedAreaSwitch = isClose;
  },
  SET_PREVIOUS_PATH(state: RootState, prevPath: string): void {
    state.previousPath = prevPath;
  },
  SET_UNSAVED_FORM(state: RootState): void {
    state.hasUnsavedForm = true;
  },
};
